import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalKeyListenerService {
  private arrowLeftPressed = new Subject<void>();
  private arrowRightPressed = new Subject<void>();

  public arrowLeftPressed$ = this.arrowLeftPressed.asObservable();
  public arrowRightPressed$ = this.arrowRightPressed.asObservable();

  public setArrowLeftPressed() {
    this.arrowLeftPressed.next();
  }

  public setArrowRightPressed() {
    this.arrowRightPressed.next();
  }
}
